import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot } from '@angular/router';
import { IndividuService } from '@Common/core/services';
import {Observable, of, throwError} from 'rxjs';
import {PageService} from '../services';
import {HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {PubSubService} from '../services/pub-sub.service';
import {typeEvents} from '../enum/type-events';
import {rolesBdc} from '../enum/roles-bdc';


@Injectable()
export class CaneditGuardService  {
  can_edit: boolean;
  constructor(private individuService: IndividuService,
              private pageService: PageService,
              private pubsubService: PubSubService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canEdit(route.params.id);
  }

  private canEdit(page_id: number): Observable<boolean> {
    return Observable.create(observer => {
      this.individuService.individu$.subscribe(_individu => {
          this.checkifcanedit(_individu, page_id).subscribe((d) => {
            observer.next(d);
            observer.complete();
          });
        }
      );
    });
  }

  private checkifcanedit(individu, pageid): Observable<boolean> {
    if (this.individuService.hasRole(individu, rolesBdc.admin) ||
      this.individuService.hasRole(individu, rolesBdc.supergestionnaire) ) {
      return of(true);
    } else if (this.individuService.hasRole(individu, rolesBdc.gestionnaire)) {
      return Observable.create(obs => {
        this.pageService.canEdit(pageid)
          .pipe(catchError((err: HttpErrorResponse) => {
            if (err.status === 403) {
              return of(false);
            }
            return throwError(err.error || `Server error : ${err} ${JSON.stringify(err)}`);
          }))
          .subscribe(data => {
              if (!data) {
                this.pubsubService.publish(typeEvents.noPageRights, 'Vous n\'avez pas les droits de modifier cette page');
              }

              obs.next(data);
              obs.complete();
            }
          );
      });
    }
  }
}
